import React, { Component } from "react";
import AddCategory from "./AddCategory";
import AddQuoteForm from "./AddQuoteForm";
import "./FormPage.scss";
export default class FormPage extends Component {
  render() {
    return (
      <div className="container-flex">
        <AddQuoteForm />
      </div>
    );
  }
}
